module.exports = __webpack_public_path__ + "h5/img/logo8.23262f4e.png";